import React from 'react'
import Translation from '../General/Translation'

const ClosePopupButton = ({translation, onClosePopup}) => (
    <div 
        className="popup-close-button has-popup-close cursor-pointer" 
        onClick={onClosePopup}
    >
         <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
            <polygon className="cls-1" points="25 1.06 23.94 0 12.5 11.44 1.06 0 0 1.06 11.44 12.5 0 23.94 1.06 25 12.5 13.56 23.94 25 25 23.94 13.56 12.5 25 1.06"/>
        </svg>
        <span className='screen-reader-text'>
            <Translation id="popupClose" trans={translation}>Close Popup</Translation>
        </span>
    </div>
)

export default ClosePopupButton